import React from 'react';
import Store from '../components/home/Store';

const StorePage = () => {
    return <Store />;
};

export default StorePage;
